import BaseUpdateRequest from "@/models/Shared/BaseUpdateRequest";

export default class UpdateRateRequest extends BaseUpdateRequest{
    rateId: string = '';
    rate: number = 0;
    fromDate: Date;
}
